import React from 'react';

function PrivacyPolicy() {
  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>Privacy Policy</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <p><em>Last Updated: December 31, 2025</em></p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to Coupon Adda. We respect your privacy and are committed to protecting your personal data.
              This privacy policy will inform you about how we look after your personal data when you visit our website
              and tell you about your privacy rights.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect and process the following data about you:</p>
            <ul>
              <li><strong>Usage Data:</strong> Information about how you use our website, including your IP address, browser type, and pages visited</li>
              <li><strong>Contact Information:</strong> Name and email address if you contact us through our contact form</li>
              <li><strong>Cookies:</strong> Data collected through cookies and similar technologies</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain our service</li>
              <li>Improve user experience</li>
              <li>Respond to your inquiries and requests</li>
              <li>Analyze website usage and trends</li>
              <li>Detect, prevent, and address technical issues</li>
            </ul>
          </section>

          <section>
            <h2>4. Cookies</h2>
            <p>
              We use cookies to enhance your browsing experience. Cookies are small files stored on your device
              that help us understand how you use our website. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2>5. Third-Party Links</h2>
            <p>
              Our website contains links to third-party websites and merchant sites. We are not responsible for
              the privacy practices of these external sites. We encourage you to read their privacy policies.
            </p>
          </section>

          <section>
            <h2>6. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. However, no method
              of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of your personal data</li>
              <li>Request deletion of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Request transfer of your personal data</li>
            </ul>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Our service is not intended for children under 13 years of age. We do not knowingly collect
              personal information from children under 13.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you of any changes by posting
              the new privacy policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us at:
              <br />
              Email: gautammukesh935@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
